import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { QUERY_KEYS } from "@/query-keys";

export const useAiEmailUpdates = () => {
  const projectId = useProjectId();
  const api = useApi();

  return {
    getUpdates: () =>
      queryOptions({
        queryKey: QUERY_KEYS.AI_EMAIL_UPDATES(projectId),
        queryFn: () => api.getAiEmailUpdateV1(),
        select: commonAPIDataSelector,
      }),
  };
};
